import ISfJobApplicationLayoutInput from './ISfJobApplicationLayoutInput';

export default interface ISfJobApplicationLayout {
	type: 'layout_30_70' | 'layout_30_30_30' | 'layout_50_50' | 'layout_70_30' | 'layout_100';
	children: (ISfJobApplicationLayout | ISfJobApplicationLayoutInput)[];
}

// Type Guard
export function isISfJobApplicationLayout(object: any | ISfJobApplicationLayout): object is ISfJobApplicationLayout {
	const formLayoutObject: ISfJobApplicationLayout = object as ISfJobApplicationLayout;
	return formLayoutObject.type !== undefined && formLayoutObject.children !== undefined;
}
